import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import RoleRedirect from "@/components/RoleRedirect";

import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import TrialForm from "@/pages/TrialForm";
import Register from "@/pages/Register";
import Legal from "@/pages/Legal";
import CancelAppointment from "@/pages/CancelAppointment";
import AdminLayout from "@/components/layouts/AdminLayout";
import TrainerLayout from "@/components/layouts/TrainerLayout";
import MemberLayout from "@/components/layouts/MemberLayout";
import ComingSoon from "@/components/ComingSoon";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import Members from "@/pages/admin/Members";
import MemberDetail from "@/pages/admin/MemberDetail";
import Trainers from "@/pages/admin/Trainers";
import Services from "@/pages/admin/Services";
import Packages from "@/pages/admin/Packages";
import Branches from "@/pages/admin/Branches";
import Payments from "@/pages/admin/Payments";
import Expenses from "@/pages/admin/Expenses";
import Reports from "@/pages/admin/Reports";
import BranchComparison from "@/pages/admin/BranchComparison";
import Calendar from "@/pages/admin/Calendar";
import Waitlist from "@/pages/admin/Waitlist";
import CRM from "@/pages/admin/CRM";
import AdminMeasurements from "@/pages/admin/AdminMeasurements";

import TrainerDashboard from "@/pages/trainer/TrainerDashboard";
import TrainerMembers from "@/pages/trainer/TrainerMembers";
import TrainerCalendar from "@/pages/trainer/TrainerCalendar";

import MemberDashboard from "@/pages/member/MemberDashboard";
import MemberPackages from "@/pages/member/MemberPackages";
import MemberProfile from "@/pages/member/MemberProfile";
import MemberAppointments from "@/pages/member/MemberAppointments";
import MemberMeasurements from "@/pages/member/MemberMeasurements";
import MemberWorkout from "@/pages/member/MemberWorkout";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/basvuru" element={<TrialForm />} />
          <Route path="/kayit" element={<Register />} />
          <Route path="/kvkk" element={<Legal doc="kvkk" />} />
          <Route path="/gizlilik" element={<Legal doc="gizlilik" />} />
          <Route path="/kosullar" element={<Legal doc="kosullar" />} />
          <Route path="/randevu-iptal/:aid/:token" element={<CancelAppointment />} />
          <Route path="/" element={<RoleRedirect />} />

          {/* ADMIN */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={["admin", "super_admin", "franchise_owner", "branch_manager"]}>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="members" element={<Members />} />
            <Route path="members/:id" element={<MemberDetail />} />
            <Route path="trainers" element={<Trainers />} />
            <Route path="services" element={<Services />} />
            <Route path="packages" element={<Packages />} />
            <Route path="branches" element={<Branches />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="waitlist" element={<Waitlist />} />
            <Route path="appointments" element={<Calendar />} />
            <Route path="crm" element={<CRM />} />
            <Route path="measurements" element={<AdminMeasurements base="/admin" />} />
            <Route path="workouts" element={<ComingSoon title="Antrenman Programları" phase={3} />} />
            <Route path="payments" element={<Payments />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="reports" element={<Reports />} />
            <Route path="branch-comparison" element={<BranchComparison />} />
            <Route path="settings" element={<ComingSoon title="Sistem Ayarları" phase={6} />} />
          </Route>

          {/* TRAINER */}
          <Route
            path="/trainer"
            element={
              <ProtectedRoute roles={["trainer"]}>
                <TrainerLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<TrainerDashboard />} />
            <Route path="members" element={<TrainerMembers />} />
            <Route path="members/:id" element={<MemberDetail />} />
            <Route path="calendar" element={<TrainerCalendar />} />
            <Route path="measurements" element={<AdminMeasurements base="/trainer" />} />
            <Route path="workouts" element={<ComingSoon title="Antrenman Programları" phase={3} />} />
          </Route>

          {/* MEMBER */}
          <Route
            path="/member"
            element={
              <ProtectedRoute roles={["member"]}>
                <MemberLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<MemberDashboard />} />
            <Route path="packages" element={<MemberPackages />} />
            <Route path="profile" element={<MemberProfile />} />
            <Route path="appointments" element={<MemberAppointments />} />
            <Route path="measurements" element={<MemberMeasurements />} />
            <Route path="workout" element={<MemberWorkout />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
    </AuthProvider>
  );
}

export default App;
